import React from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from "@material-ui/core";
import { RawLinkButton } from "../../../LinkButton";
import IntegrationAttachmentUpload from "../../IntegrationAttachmentUpload";
import { useIntegrationContext } from "../../contexts/IntegrationContext";

export interface IAPIFieldsDialogProps {
  integrationName: string;
  integrationID: number;
}

const SubmitFieldsXMLDialog = (props: IAPIFieldsDialogProps) => {
  const { integrationName, integrationID } = props;
  const { showXMLFieldsDialog, setShowXMLFieldsDialog } = useIntegrationContext();

  return (
    <Dialog
      open={showXMLFieldsDialog}
      onClose={() => setShowXMLFieldsDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
    >
      <DialogTitle id="alert-dialog-title">{`Submit Custom API Fields for ${integrationName}`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Use the SDK Explorer of{" "}
          <Link href="/docs?id=qmlativ/sdk/download.html" target="_blank">
            Qmlativ's .Net SDK
          </Link>{" "}
          to generate a list of fields this integration intends to use via Custom API. The most recent file's contents will display in the Pending fields lists
          below.
        </DialogContentText>
        <IntegrationAttachmentUpload integrationId={integrationID.toString()} />
      </DialogContent>
      <DialogActions>
        <RawLinkButton onClick={() => setShowXMLFieldsDialog(false)} color="primary">
          Close
        </RawLinkButton>
      </DialogActions>
    </Dialog>
  );
};

export default SubmitFieldsXMLDialog;
